import { render, staticRenderFns } from "./ArgesTarjetasAlta.vue?vue&type=template&id=907e6588&scoped=true&"
import script from "./ArgesTarjetasAlta.vue?vue&type=script&lang=ts&"
export * from "./ArgesTarjetasAlta.vue?vue&type=script&lang=ts&"
import style0 from "./ArgesTarjetasAlta.vue?vue&type=style&index=0&id=907e6588&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907e6588",
  null
  
)

export default component.exports